<div style="background-color: #ffffff" class="paddedContent">
  <app-edit-catalog-item
    [isNew]="true"
    [itemId]="itemId"
    [catalogId]="catalogId"
    (saved)="handleSaved()"
    (cancelled)="handleCancelled()"
  ></app-edit-catalog-item>
</div>
